import React, {useEffect, useState} from 'react';
import './CardexProductSadanShopTypeTwo.scss';
import DynaTable from "../../MyTable/DynaTable";
import Loader from "../../Loader";
import Modal, {ModalBody, ModalHeader} from "../../Modal";
import ModalSelectProduct from "../../CardexProduct/ModalSelectProduct/ModalSelectProduct";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../utils/utilsData";
import {useLocation} from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import NumericFunction from "../../../utils/NumericFunction";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import utilsFunction from "../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../utils/exportCSVFile";
import numericFunction from "../../../utils/NumericFunction";

const CardexProductSadanShopTypeTwo = () => {

  const location = useLocation();
  const [isLoad, setIsLoad] = useState(false);
  const [isLoadCardex, setIsLoadCardex] = useState(true);
  const [dataFromModal, setDataFromModal] = useState({
    column: [],
    data: [],
    overallReport: {},
    productData: {},
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [anbarFilter, setAnbarFilter] = useState({});
  const [dateFilter, setDateFilter] = useState({});
  const [productId, setProductId] = useState("");
  const [options, setOption] = useState([])
  const [anbarValue, setAnbarValue] = useState({value: "", label: ""})
  const [runFilter, setRunFilter] = useState(0)

  useEffect(() => {
    if (
      location.state.CardexData !== undefined ||
      location.state.CardexData !== ""
    ) {
      setDataFromModal(location.state.CardexData);
      setAnbarFilter({enable: false, id: ""})
      setDateFilter({enable: false, startDate: "", endDate: ""})
      setProductId(location.state.productId)
    }
  }, [location.state.CardexData]);

  useEffect(() => {
    _axios.get(prefixUrl() + "/cardex/?request=storesList").then((response) => {
      if (response.data.status) {
        setOption(response.data.data);
        setAnbarValue(response.data.data[0])
        setIsLoad(true);
      } else {
        toast.error(response.data.message);
      }
    });
  }, []);

  const showAllProductData = () => {
    setIsLoadCardex(false)
    _axios.get(prefixUrl() + "/cardex/?request=productCardex&productId=all" + "&storeFilter=" + JSON.stringify(anbarFilter) + "&dateFilter=" + JSON.stringify(dateFilter))
      .then((response) => {
        if (response.data.status) {
          setAnbarFilter({enable: false, id: ""})
          setDateFilter({enable: false, startDate: "", endDate: ""})
          setAnbarValue(options[0])
          setDataFromModal(response.data)
          setProductId("all")
          setRunFilter(runFilter + 1)
        } else {
          toast.error(response.data.message);
        }
      });
  }
  const addDataModalHandler = (inventoryId) => {

    _axios.get(prefixUrl() + "/cardex/?request=productCardex&productId=" + inventoryId?.productId + "&storeFilter=" + JSON.stringify(anbarFilter) + "&dateFilter=" + JSON.stringify(dateFilter))
      .then((response) => {
        if (response.data.status) {
          response.data.column.push({
            field: "edit",
            title: "ویرایش",
            headerFilter: true,
          });
          setAnbarFilter({enable: false, id: ""})
          setDateFilter({enable: false, startDate: "", endDate: ""})
          setAnbarValue(options[0])
          setProductId(inventoryId?.productId)
          setDataFromModal(response.data);
          setIsOpenModal(false)
          setIsLoadCardex(true)
          setRunFilter(runFilter + 1)
        } else {
          toast.error(response.data.message);
        }
      });
  };

  useEffect(() => {

    if (runFilter !== 0) {
      setIsLoadCardex(false)
      _axios.get(prefixUrl() + "/cardex/?request=productCardex&productId=" + productId + "&storeFilter=" + JSON.stringify(anbarFilter) + "&dateFilter=" + JSON.stringify(dateFilter))
        .then((response) => {
          if (response.data.status) {
            response.data.column.push({
              field: "edit",
              title: "ویرایش",
              headerFilter: true,
            });
            setIsLoadCardex(true)
            setDataFromModal(response.data);
            setIsOpenModal(false);
          } else {
            toast.error(response.data.message);
            setIsLoadCardex(true)
          }
        })
    }
  }, [runFilter])

  const customStyles = {

    control: (provided: Record<string, unknown>) => ({
      ...provided,
      height: 42,
      borderRadius: 10,
      '&:hover': {
        border: '1px solid var(--primary-p-1, #5D70B5)',
      },
      '&:focus': {
        border: '1px solid white',
      },
    }),

    option: (base, state) => ({
      ...base,
      color: state.isSelected ? "white" : "#6D6D6D",
      backgroundColor: state.isSelected ? "var(--primary-p-1, #5D70B5)" : "white",
      padding: ".5rem 3rem .5rem .5rem",
      cursor: "pointer",
      fontSize: 14
    }),
  };

  const letGoXLS = () => {

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const fileName =
      "کاردکس کالا" + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(dataFromModal?.middleColumn, dataFromModal?.middleData)
    exportXLSXFile(normalizeData, fileName, "")

  }

  const letGoXLSTwo = () => {

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

    let printData = []
    dataFromModal?.data.forEach((v) => {
      printData.push({
        row: v.row,
        operationType: v.operationType,
        particleId: v.particleId,
        mainId: v.mainId,
        date: v.date,
        weight: v.weight,
        price: v.price,
        sellPrice: v.sellPrice,
        totalPrice: v.totalPrice,
        costAndBenefit: v.costAndBenefit,
        remainingWeight: v.remainingWeight,
        remainingValue: v.remainingValue
      })
    })
    const fileName = "کاردکس کالا" + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(dataFromModal?.column, printData)
    //exportCSVFile(normalizeData, fileName, "")
    exportXLSXFile(normalizeData, fileName, "")
  }

  return (

    <div className="main-cardex-two">

      {isLoad ?
        <>
          <Modal
            isOpen={isOpenModal}
            modalCallback={() => setIsOpenModal(false)}
            widthProp={1000}
          >
            <ModalHeader title={"انتخاب کالا"}/>

            <ModalBody>
              <>
                <div
                  className={""}
                  style={{
                    padding: "5px",
                    overflow: "scroll",
                    margin: "auto",
                    width: "900px",
                  }}>
                  <ModalSelectProduct
                    addHandler={addDataModalHandler}
                    closeModal={() => setIsOpenModal(false)}
                  />
                </div>
              </>
            </ModalBody>
          </Modal>

          <div className="top-side">

            <div className="filter-side">

              <div className="list-filter">

                <div className="button-product">
                  <button className="add-product" style={{width: '40%'}} onClick={showAllProductData}>تمامی کالاها
                  </button>
                  <button className="add-product" style={{width: '60%'}} onClick={() => setIsOpenModal(true)}>انتخاب
                    کالا
                  </button>
                </div>

                <div className="date-input">
                  <label>انتخاب انبار</label>
                  <Select options={options}
                          styles={customStyles}
                          value={anbarValue}
                          onChange={(e) => {
                            setAnbarValue({value: e.value, label: e.label})
                            if (e.value !== -1) {
                              setAnbarFilter({enable: true, id: e.value})
                            } else {
                              setAnbarFilter({enable: false, id: ""})
                            }
                          }}/>
                </div>

                <div className="date-input">
                  <label>از تاریخ</label>
                  <DatePicker
                    onChange={(date) => {
                      if (date) {
                        setDateFilter({
                          ...dateFilter,
                          startDate: NumericFunction.p2e(date.toLocaleString()), enable: true
                        });
                      } else {
                        setDateFilter({
                          ...dateFilter,
                          startDate: "", enable: false
                        })
                      }
                    }}
                    calendar={persian}
                    className="form-control"
                    placeholder="انتخاب تاریخ"
                    locale={persian_fa}
                    value={dateFilter.startDate}
                    calendarPosition="bottom-right"
                    hideOnScroll
                  />
                </div>

                <div className="date-input">
                  <label>تا تاریخ</label>
                  <DatePicker
                    onChange={(date) => {
                      if (date) {
                        setDateFilter({
                          ...dateFilter,
                          endDate: NumericFunction.p2e(date.toLocaleString()), enable: true
                        });
                      } else {
                        setDateFilter({
                          ...dateFilter,
                          endDate: "", enable: false
                        })
                      }
                    }}
                    calendar={persian}
                    className="form-control"
                    placeholder="انتخاب تاریخ"
                    locale={persian_fa}
                    value={dateFilter.endDate}
                    calendarPosition="bottom-right"
                    hideOnScroll
                  />
                </div>
              </div>

              <div className="button-filter">
                <button className="add-filter" onClick={() => setRunFilter(runFilter + 1)}>اعمال فیلتر</button>
              </div>


            </div>
            {isLoadCardex ?
              <>
                <div className="detail-side">
                  <div className="inline-data">
                    <h5>کد کـالا &nbsp; :</h5>
                    <p>{dataFromModal?.id ? numericFunction.e2p(dataFromModal?.id) : "تمامی کالا ها"}</p>
                  </div>

                  <div className="inline-data">
                    <h5>نام کـالا &nbsp; :</h5>
                    <p>{dataFromModal?.name ? dataFromModal?.name : "تمامی کالا ها"}</p>
                  </div>

                  <div className="inline-data">
                    <h5> نام انبـار &nbsp; :</h5>
                    <p>{dataFromModal?.storeName}</p>
                  </div>

                  <div className="inline-data">
                    <h5>واحـد &nbsp; :</h5>
                    <p>{dataFromModal?.unit}</p>
                  </div>

                  <div className="xls-side">
                    <button onClick={letGoXLS}>دانلود اکسل</button>
                  </div>
                </div>

                <div className="table-side">
                  {(dataFromModal.middleData).length > 0 && (
                    <>
                      <div className="single-column-row">
                        <p className="box-column" style={{width: '4%'}}>شرح</p>
                        <p className="box-column" style={{width: '7%'}}>ابتدای دوره</p>
                        <p className="box-column" style={{width: '36%'}}>وارده</p>
                        <p className="box-column" style={{width: '46%'}}>صادره</p>
                        <p className="box-column" style={{width: '6%'}}>مانده</p>
                      </div>
                      <DynaTable
                        column={dataFromModal?.middleColumn}
                        data={dataFromModal?.middleData}
                        className={"solid-table-light"}
                        onRowClick={""}
                        mainWidth={"100%"}
                        boldText={dataFromModal?.boldText}
                      />
                    </>
                  )}
                </div>
              </> :
              <div style={{paddingTop: '2rem'}}><Loader/></div>}
          </div>

          {isLoadCardex &&
            <div className="bottom-side">
              {Object.keys(dataFromModal.data).length > 0 && (
                <>
                  <div className="xls-side">
                    <button onClick={letGoXLSTwo}>دانلود اکسل</button>
                  </div>
                  <DynaTable
                    column={dataFromModal?.column}
                    data={dataFromModal?.data}
                    className={"solid-table-light"}
                    onRowClick={""}
                    priceFields={dataFromModal?.priceFields}
                    mainWidth={"100%"}
                  />
                </>

              )}
            </div>}
        </> : <Loader/>}
    </div>
  );
};

export default CardexProductSadanShopTypeTwo;